import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NewsletterService } from '../../../shared/services/newsletter.service';
import { NewslettersDataSource } from './newsletters.datasource';
import { ISubscriber, IPaginationNewsletter } from './ipagination-newsletter.model';
import { DataTableTranslations, DataTable, DataTableParams } from 'angular-datatables-all-versions';

@Component({
  selector: 'app-modal-newsletter',
  templateUrl: './modal-newsletter.component.html',
  styleUrls: ['./modal-newsletter.component.css']
})
export class ModalNewsletterComponent implements OnInit {

  @ViewChild(DataTable,{static:false}) table: DataTable;

  public dataSource: NewslettersDataSource;
  public newsletters: ISubscriber[];
  public newslettersCount = 0;
  public translations = <DataTableTranslations>{
    indexColumn: 'Num.',
    expandColumn: 'Informations',
    selectColumn: 'Sélectionner',
    paginationLimit: 'Max.',
    paginationRange: 'Résultats'
  }

  constructor(public activeModal: NgbActiveModal, private service: NewsletterService) {
    this.dataSource = new NewslettersDataSource(service);
  }

  ngOnInit() {
    this.dataSource.load();
    this.dataSource.pagination.subscribe(
      (data: IPaginationNewsletter) => {
        if (data && data.hasOwnProperty('meta')) {
          this.newslettersCount = data.meta.pagination.total_objects;
          this.newsletters = data.subscribers;
        }
      }
    );
  }

  reload(_params: DataTableParams) {
    this.dataSource.load('', true, this.table.offset, this.table.limit);
  }

  export() {
    this.service.all().subscribe(
      (data: ISubscriber[]) => {
        const exportdata: any[] = [];
        data.forEach(item => {
          exportdata.push({
            'Email': item.email,
            'Date': item.created_at
          });
        });

        const csvData = this.convertToCSV(exportdata);
        const blob = new Blob([csvData], { type: 'text/csv' });
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveBlob(blob, 'newsletters.csv');
        } else {
          const a = window.document.createElement('a');
          a.href = window.URL.createObjectURL(blob);
          a.download = 'newsletters.csv';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      }
    );
  }

  cellColor(car) {
    return 'rgb(255, 255,' + (155 + Math.floor(100 - ((car.rating - 8.7) / 1.3) * 100)) + ')';
  }

  private convertToCSV(objArray) {
    const replacer = (_key, value) => value === null ? '' : value
    const header = Object.keys(objArray[0])
    let csv = objArray.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(';'))
    csv.unshift(header.join(';'));
    csv = csv.join('\r\n')
    return csv;
  }
}
